import { Banner } from '#/components/Banner/Banner';
import { assertNever } from '#/service/utils';

import { useBannerManager } from './BannerManager.hook';

export const BannerManager = () => {
  const { banner, dismissExpiryBanner } = useBannerManager();

  if (!banner) {
    return null;
  }

  switch (banner) {
    case 'offline':
      return <Banner error={false} message="error.networkConnection.message" />;

    case 'paymentMethodExpiresSoon':
      return (
        <Banner
          dismissAriaLabel="banner.paymentMethodDismiss"
          error={true}
          message="banner.paymentMethodExpiresSoon"
          onDismiss={dismissExpiryBanner}
        />
      );

    case 'paymentMethodExpired':
      return (
        <Banner
          dismissAriaLabel="banner.paymentMethodDismiss"
          error={true}
          message="banner.paymentMethodExpired"
          onDismiss={dismissExpiryBanner}
        />
      );

    default:
      assertNever(banner);
  }
};
